import { gql } from "@apollo/client"

export const Login = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      userSession {
        oaTag
      }
      errors
    }
  }
`

export const Account = gql`
  query Account($rsvpPortalId: ID) {
    me(rsvpPortalId: $rsvpPortalId) {
      emailAddress
      verified(rsvpPortalId: $rsvpPortalId)
      phoneNumberTaken
      mobilePhoneNumber
      firstName
      lastName
      regionCode
      mobileCountryPrefix
    }
  }
`

export const IsUserLoggedIn = gql`
  query IsUserLoggedIn {
    isLoggedIn @client
  }
`
